var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1995 9.54352L9.13025 10.8805C7.47338 9.90705 6.09272 8.52639 5.11925 6.86952L6.45625 5.80027C6.61298 5.67485 6.72374 5.50105 6.77123 5.30601C6.81873 5.11098 6.80027 4.90571 6.71875 4.72227L5.49987 1.9774C5.41246 1.7807 5.25804 1.62144 5.06413 1.52801C4.87022 1.43458 4.64943 1.41306 4.44112 1.46727L2.12062 2.0684C1.90418 2.12515 1.71603 2.25922 1.59173 2.44527C1.46742 2.63132 1.41558 2.85647 1.446 3.07815C1.85313 5.97767 3.19318 8.66582 5.26357 10.7362C7.33395 12.8066 10.0221 14.1466 12.9216 14.5538C13.1432 14.5844 13.3683 14.5326 13.5543 14.4082C13.7402 14.2839 13.8741 14.0956 13.9305 13.8791L14.5325 11.5595C14.5867 11.3512 14.5652 11.1304 14.4718 10.9365C14.3783 10.7426 14.2191 10.5882 14.0224 10.5008L11.2775 9.2819C11.0941 9.20058 10.889 9.18215 10.694 9.22946C10.4991 9.27678 10.3252 9.38719 10.1995 9.54352V9.54352Z",
    stroke: "#B5B7C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a1cf89e0eb71ce24aaa625e721380c14.svg";
export { ForwardRef as ReactComponent };